import pluralize from 'pluralize';

import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

import { IWfaLabelOptions } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';

export const SESSIONS_PERIOD_OPTIONS: OptionType[] = [
	DEFAULT_PERIOD_OPTION,
	{ value: 60, label: 'Last 60 days' },
	{ value: 90, label: 'Last 90 days' },
	{ value: 'all', label: 'All Sessions' }
];

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {
		className: 'search-filter'
	}
};

const sessionsPeriodFilter: ISelectFilterDefinition = {
	id: 'sessionsPeriod',
	label: 'sessions period',
	filterType: 'select',
	defaultValue: [DEFAULT_PERIOD_OPTION],
	componentProps: {
		placeholder: 'Select Sessions Period',
		isMultiple: false,
		id: 'sessionsPeriod',
		label: 'Sessions Period',
		listboxWidth: '150px'
	}
};

export const createdByFilter: ISelectFilterDefinition = {
	id: 'createdBy',
	label: 'created by',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Created By',
		allSelectedPlaceholder: 'All Created By',
		someItemsSelectedText: (numberOfItems: number) => `Created By (${numberOfItems})`,
		isMultiple: true,
		className: 'created-by-filter',
		id: 'createdBy',
		label: 'Created By',
		listboxWidth: '150px'
	}
};

const mapLabelOptionsToFilterDefinitions = (
	labelOptions?: IWfaLabelOptions[]
): ISelectFilterDefinition[] =>
	labelOptions?.map(({ labelKey, labelName }) => ({
		id: labelKey,
		label: labelName,
		defaultValue: [],
		filterType: 'select',
		componentProps: {
			placeholder: `Select ${labelName}`,
			allSelectedPlaceholder: `All ${labelName}`,
			someItemsSelectedText: (numberOfItems: number) => `${labelName} (${numberOfItems})`,
			isMultiple: true,
			className: 'label-dynamic-filter',
			id: labelKey,
			label: pluralize.singular(labelName),
			listboxWidth: '150px'
		}
	})) ?? [];

export const getWfaSessionsFilterDefinitions = (
	labelOptions?: IWfaLabelOptions[],
	createdByOptions?: ISelectFilterDefinition
): IFilterDefinition[] => [
	searchFilter,
	...mapLabelOptionsToFilterDefinitions(labelOptions),
	createdByOptions,
	sessionsPeriodFilter
];
